enum ContactFacetType {
    Employee,
    Patient,
    Relative
}

export { ContactFacetType };
